import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    overflow: visible;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: calc(${layout.mobileNavHeight} + ${space['space-2000']});

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space['space-800']};
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space['space-200']};
`;

export const Heading = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  text-align: center;
  line-height: ${primitives.typography.lineHeight.tight};
  letter-spacing: ${primitives.typography.tracking.tight};
  margin: ${space['space-1600']} 0 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.tertiary};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  margin-top: ${space['space-1000']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0 min(${space['space-1400']}, 8.5%);
  }
`;

export const OutlinedCard = styled.div`
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xl']};
`;

export const CardSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  padding: ${space['space-800']} ${space['space-600']};

  & + & {
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }
`;

export const GuestModeOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};

  & > [role='radiogroup'] {
    flex-direction: column;
    gap: ${space['space-200']};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    & > [role='radiogroup'] {
      flex-direction: row;
      gap: ${space['space-400']};
    }
  }
`;

export const PreferencesCardBody = styled.div`
  padding: 0 ${space['space-600']} ${space['space-600']};
`;

export const ActionBarArea = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    bottom: 0;
    background: ${semantic.bg.canvas};
    border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    padding-bottom: ${space['space-600']};
    z-index: 2;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: 0 min(${space['space-1000']}, 6%);
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${semantic.text.primary};
`;

export const PageError = styled.div`
  padding: ${space['space-600']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xl']};
`;
